// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    padding: 0;
    margin: 0;
}

.MAMCQheading{
    margin: 0 5vw 0 5vw;
    display: flex;
    align-items: center;
}

.MAMCQactivity-image{
    width: 70px;
    margin-right: 20px;
}

.MAMCQactivity-image img{
    width: 100%;
}

.MAMCQactivity-text{
    color: rgb(227, 135, 35);
    font-size: 20px;
}

.MAMCQcontainer{
    margin: 0 5vw 0 5vw;
}

.MAMCQhead{
    display: flex;
}

.MAMCQquestions{
    flex: 5 1;
    background-color: rgb(227, 135, 35);
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: aliceblue;
    border-radius: 10px 0 0 10px;
    
}


#total-questions{
    margin-left: 2px;
}

.MAMCQprogress-bar{
    height: 5px;
    width: 130px;
    background-color: rgb(154, 168, 168);
    border-radius: 5px;
    margin-top: 5px;
}

#progress{
    height: 5px;
    width: 0;
    background-color: aqua;
    border-radius: 5px;
}

.MAMCQscore{
    flex: 1 1;
    padding-top: 3px;
    display: flex;
    flex-direction: column;
    background-color: rgb(64, 163, 64);
    color: white;
    text-align: center;
    border-radius: 0px 10px 10px 0;
    justify-content: space-between;
}

.MAMCQnumbered-score{
    background-color: rgb(158, 196, 158);
    border-radius: 15px;
    padding: 10px;

}

.MAMCQbody{
    background-color: rgb(250, 240, 214);
    display: flex;
    border-radius: 15px 0 0 15px;
    
}

.MAMCQremaining-body{
    background-color: rgb(250, 240, 214);
    flex: 5 1;
    padding: 20px;
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    row-gap: 20px;
    border-radius: 15px 0 0 15px;
}

.MAMCQquestion{
    border-width: 2px;
    border-color: rgb(227, 135, 35);
    border-style: solid;
    text-align: center;
    color: rgb(227, 135, 35);
    font-size: 30px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 0.3fr;
    max-height: 380px;
    overflow-y: scroll;
}


.MAMCQmental-question-section{
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.MAMCQmcq-text{
    text-align: left;
    margin-left: 20px;
}

.MAMCQmcq-options{
    text-align: left;
    margin-left: 20px;
}
.MAMCQmental-question-section h4{
    margin-top: 15px;
    color: black;

}

#MAMCQmental-question-text{
    font-size: 30px;
    color: rgb(227, 135, 35);
}

.MAMCQmental-question-section img{
    width: 30px;
    margin-right: 5px;
}

.MAMCQplay-question{
    background-color: rgb(250, 240, 214);
    border: none;
    cursor: pointer;
}

.MAMCQplay-question img{
    flex: 1 1;
    background-color: rgb(250, 240, 214);
    border: none;
    cursor: pointer;
}

.MAMCQplay-question img:active{
    width: 90px;
}

.MAMCQpicture img{
    width: 300px;
}


.MAMCQtime{
    display: flex;
    border: 2px solid red;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.MAMCQtime-text{
    background-color: red;
    color: white;
    border-radius: 18px;
    display: flex;
    align-items: center;
    padding: 15px;
}

.MAMCQtimer{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 15px;
}

.MAMCQmarks{
    display: flex;
    border: 2px solid rgb(170, 96, 0);;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.MAMCQmarks-text{
    background-color: rgb(170, 96, 0);
    color: white;
    border-radius: 18px;
    display: flex;
    align-items: center;
    padding: 15px;
}

.MAMCQmarker{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 15px;
}

.MAMCQinstructions-dropdown{
    background-color: rgb(250, 240, 214);
    color: rgb(227, 135, 35);
    padding: 15px;
    font-size: 15px;
}

.MAMCQanswer-submit input::placeholder{
    font-size: 15px;
}

.MAMCQanswer{
    border: none;
    border-radius: 8px;
    padding: 15px 10px;
}

#MAMCQsubmission{
    border: none;
    background-color: rgb(18, 18, 192);
    border-radius: 8px;
    color: white;
    padding: 15px 15px;
    cursor: pointer;
}

#marks-color{
    flex: 1 1;
    background-color: rgb(254, 236, 242);
    border: 1px solid rgb(227, 135, 35);
    border-radius: 0 10px 10px 0;
    overflow: scroll;
    max-height: 300px;
}

.MAMCQbox{
    display: flex;
    border: 2px solid rgb(227, 135, 35);
    margin: 0 10px 2px 10px;
}

.MAMCQbox1{
    flex: 1 1;
    border-width: 0 2px 0 0;
    border-color: rgb(227, 135, 35);
    border-style: solid;
    text-align: center;
}
.MAMCQbox2{
    flex: 1 1;
    background-color: red;
    
}

.MAMCQremarks{
    margin: 0 5vw 0 5vw;
    display: flex;
    justify-content: space-between;
}

.MAMCQsubmitButton{
    border: none;
    background-color: rgb(18, 18, 192);
    border-radius: 8px;
    color: white;
    padding: 10px 10px;
    cursor: pointer;
    margin-bottom: 5px;
}
.MAMCQsubmitButton h5{
    font-size: 16px;
}

.mcq-option-label {
    font-size: 25px; /* Adjust the font size of the options */
    margin-left: 8px; /* Adds space between the radio button and text */
    line-height: 1.5; /* Optional: for better spacing between lines */
    color: #333; /* Optional: change text color */
}
.mcq-radio {
    width: 18px; /* Adjust for larger radio button */
    height: 18px; /* Adjust for larger radio button */
    margin-right: 10px; /* Space between button and label */
    cursor: pointer; /* Optional: makes the button clickable */
}

/* Add media queries for mobile and tablet */
@media screen and (max-width: 1024px) {
    .MAMCQremaining-body {
        flex-direction: column;
    }

    .MAMCQquestion-container {
        order: 3; /* Move question to last */
    }

    .MApicture {
        order: 2; /* Move picture to middle */
    }

    .MAMCQtime-marks {
        order: 1; /* Move time-marks to first */
    }

    /* Adjust other styles for better mobile view */
    .MAMCQquestion {
        width: 100%;
        max-height: none;
    }

    .MApicture img {
        width: 100%;
        max-width: 300px;
        margin: 10px auto;
        display: block;
    }

    .MAMCQtime-marks {
        width: 100%;
        margin-bottom: 20px;
    }

    /* Improve touch targets */
    .mcq-radio {
        width: 24px;
        height: 24px;
    }

    .mcq-option-label {
        font-size: 16px;
        padding: 10px 0;
    }

    /* Adjust question text size */
    #MAMCQmental-question-text {
        font-size: 18px;
    }

    /* Make submit button more prominent */
    .MAMCQsubmitButton {
        width: 100%;
        padding: 15px;
        margin: 10px 0;
    }
}

/* Additional tablet-specific adjustments */
@media screen and (min-width: 768px) and (max-width: 1024px) {
    .MAMCQquestion {
        font-size: 24px;
        width: 100%;
    }

    .mcq-option-label {
        font-size: 18px;
    }

    .MApicture img {
        max-width: 400px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Activities/MCQActivity/MCQActivity.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;;AAEhC;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,4BAA4B;;AAEhC;;AAEA;IACI,oCAAoC;IACpC,SAAO;IACP,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,oCAAoC;IACpC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,oCAAoC;IACpC,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,qBAAqB;;AAEzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe,EAAE,wCAAwC;IACzD,gBAAgB,EAAE,iDAAiD;IACnE,gBAAgB,EAAE,+CAA+C;IACjE,WAAW,EAAE,gCAAgC;AACjD;AACA;IACI,WAAW,EAAE,mCAAmC;IAChD,YAAY,EAAE,mCAAmC;IACjD,kBAAkB,EAAE,mCAAmC;IACvD,eAAe,EAAE,yCAAyC;AAC9D;;AAEA,4CAA4C;AAC5C;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ,EAAE,0BAA0B;IACxC;;IAEA;QACI,QAAQ,EAAE,2BAA2B;IACzC;;IAEA;QACI,QAAQ,EAAE,6BAA6B;IAC3C;;IAEA,+CAA+C;IAC/C;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA,0BAA0B;IAC1B;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA,8BAA8B;IAC9B;QACI,eAAe;IACnB;;IAEA,sCAAsC;IACtC;QACI,WAAW;QACX,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA,2CAA2C;AAC3C;IACI;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["*{\n    padding: 0;\n    margin: 0;\n}\n\n.MAMCQheading{\n    margin: 0 5vw 0 5vw;\n    display: flex;\n    align-items: center;\n}\n\n.MAMCQactivity-image{\n    width: 70px;\n    margin-right: 20px;\n}\n\n.MAMCQactivity-image img{\n    width: 100%;\n}\n\n.MAMCQactivity-text{\n    color: rgb(227, 135, 35);\n    font-size: 20px;\n}\n\n.MAMCQcontainer{\n    margin: 0 5vw 0 5vw;\n}\n\n.MAMCQhead{\n    display: flex;\n}\n\n.MAMCQquestions{\n    flex: 5;\n    background-color: rgb(227, 135, 35);\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: aliceblue;\n    border-radius: 10px 0 0 10px;\n    \n}\n\n\n#total-questions{\n    margin-left: 2px;\n}\n\n.MAMCQprogress-bar{\n    height: 5px;\n    width: 130px;\n    background-color: rgb(154, 168, 168);\n    border-radius: 5px;\n    margin-top: 5px;\n}\n\n#progress{\n    height: 5px;\n    width: 0;\n    background-color: aqua;\n    border-radius: 5px;\n}\n\n.MAMCQscore{\n    flex: 1;\n    padding-top: 3px;\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(64, 163, 64);\n    color: white;\n    text-align: center;\n    border-radius: 0px 10px 10px 0;\n    justify-content: space-between;\n}\n\n.MAMCQnumbered-score{\n    background-color: rgb(158, 196, 158);\n    border-radius: 15px;\n    padding: 10px;\n\n}\n\n.MAMCQbody{\n    background-color: rgb(250, 240, 214);\n    display: flex;\n    border-radius: 15px 0 0 15px;\n    \n}\n\n.MAMCQremaining-body{\n    background-color: rgb(250, 240, 214);\n    flex: 5;\n    padding: 20px;\n    display: flex;\n    flex-direction: row;\n    column-gap: 10px;\n    row-gap: 20px;\n    border-radius: 15px 0 0 15px;\n}\n\n.MAMCQquestion{\n    border-width: 2px;\n    border-color: rgb(227, 135, 35);\n    border-style: solid;\n    text-align: center;\n    color: rgb(227, 135, 35);\n    font-size: 30px;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 0.3fr;\n    max-height: 380px;\n    overflow-y: scroll;\n}\n\n\n.MAMCQmental-question-section{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.MAMCQmcq-text{\n    text-align: left;\n    margin-left: 20px;\n}\n\n.MAMCQmcq-options{\n    text-align: left;\n    margin-left: 20px;\n}\n.MAMCQmental-question-section h4{\n    margin-top: 15px;\n    color: black;\n\n}\n\n#MAMCQmental-question-text{\n    font-size: 30px;\n    color: rgb(227, 135, 35);\n}\n\n.MAMCQmental-question-section img{\n    width: 30px;\n    margin-right: 5px;\n}\n\n.MAMCQplay-question{\n    background-color: rgb(250, 240, 214);\n    border: none;\n    cursor: pointer;\n}\n\n.MAMCQplay-question img{\n    flex: 1;\n    background-color: rgb(250, 240, 214);\n    border: none;\n    cursor: pointer;\n}\n\n.MAMCQplay-question img:active{\n    width: 90px;\n}\n\n.MAMCQpicture img{\n    width: 300px;\n}\n\n\n.MAMCQtime{\n    display: flex;\n    border: 2px solid red;\n    height: 40px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.MAMCQtime-text{\n    background-color: red;\n    color: white;\n    border-radius: 18px;\n    display: flex;\n    align-items: center;\n    padding: 15px;\n}\n\n.MAMCQtimer{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 15px;\n}\n\n.MAMCQmarks{\n    display: flex;\n    border: 2px solid rgb(170, 96, 0);;\n    height: 40px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.MAMCQmarks-text{\n    background-color: rgb(170, 96, 0);\n    color: white;\n    border-radius: 18px;\n    display: flex;\n    align-items: center;\n    padding: 15px;\n}\n\n.MAMCQmarker{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 15px;\n}\n\n.MAMCQinstructions-dropdown{\n    background-color: rgb(250, 240, 214);\n    color: rgb(227, 135, 35);\n    padding: 15px;\n    font-size: 15px;\n}\n\n.MAMCQanswer-submit input::placeholder{\n    font-size: 15px;\n}\n\n.MAMCQanswer{\n    border: none;\n    border-radius: 8px;\n    padding: 15px 10px;\n}\n\n#MAMCQsubmission{\n    border: none;\n    background-color: rgb(18, 18, 192);\n    border-radius: 8px;\n    color: white;\n    padding: 15px 15px;\n    cursor: pointer;\n}\n\n#marks-color{\n    flex: 1;\n    background-color: rgb(254, 236, 242);\n    border: 1px solid rgb(227, 135, 35);\n    border-radius: 0 10px 10px 0;\n    overflow: scroll;\n    max-height: 300px;\n}\n\n.MAMCQbox{\n    display: flex;\n    border: 2px solid rgb(227, 135, 35);\n    margin: 0 10px 2px 10px;\n}\n\n.MAMCQbox1{\n    flex: 1;\n    border-width: 0 2px 0 0;\n    border-color: rgb(227, 135, 35);\n    border-style: solid;\n    text-align: center;\n}\n.MAMCQbox2{\n    flex: 1;\n    background-color: red;\n    \n}\n\n.MAMCQremarks{\n    margin: 0 5vw 0 5vw;\n    display: flex;\n    justify-content: space-between;\n}\n\n.MAMCQsubmitButton{\n    border: none;\n    background-color: rgb(18, 18, 192);\n    border-radius: 8px;\n    color: white;\n    padding: 10px 10px;\n    cursor: pointer;\n    margin-bottom: 5px;\n}\n.MAMCQsubmitButton h5{\n    font-size: 16px;\n}\n\n.mcq-option-label {\n    font-size: 25px; /* Adjust the font size of the options */\n    margin-left: 8px; /* Adds space between the radio button and text */\n    line-height: 1.5; /* Optional: for better spacing between lines */\n    color: #333; /* Optional: change text color */\n}\n.mcq-radio {\n    width: 18px; /* Adjust for larger radio button */\n    height: 18px; /* Adjust for larger radio button */\n    margin-right: 10px; /* Space between button and label */\n    cursor: pointer; /* Optional: makes the button clickable */\n}\n\n/* Add media queries for mobile and tablet */\n@media screen and (max-width: 1024px) {\n    .MAMCQremaining-body {\n        flex-direction: column;\n    }\n\n    .MAMCQquestion-container {\n        order: 3; /* Move question to last */\n    }\n\n    .MApicture {\n        order: 2; /* Move picture to middle */\n    }\n\n    .MAMCQtime-marks {\n        order: 1; /* Move time-marks to first */\n    }\n\n    /* Adjust other styles for better mobile view */\n    .MAMCQquestion {\n        width: 100%;\n        max-height: none;\n    }\n\n    .MApicture img {\n        width: 100%;\n        max-width: 300px;\n        margin: 10px auto;\n        display: block;\n    }\n\n    .MAMCQtime-marks {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    /* Improve touch targets */\n    .mcq-radio {\n        width: 24px;\n        height: 24px;\n    }\n\n    .mcq-option-label {\n        font-size: 16px;\n        padding: 10px 0;\n    }\n\n    /* Adjust question text size */\n    #MAMCQmental-question-text {\n        font-size: 18px;\n    }\n\n    /* Make submit button more prominent */\n    .MAMCQsubmitButton {\n        width: 100%;\n        padding: 15px;\n        margin: 10px 0;\n    }\n}\n\n/* Additional tablet-specific adjustments */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n    .MAMCQquestion {\n        font-size: 24px;\n        width: 100%;\n    }\n\n    .mcq-option-label {\n        font-size: 18px;\n    }\n\n    .MApicture img {\n        max-width: 400px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
